import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c33a7b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-upc fs-3x" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-upc fs-3x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "d-flex flex-column VZ_TABLE_BUTTON selectedControled" }, _ctx.dynamicAttrs), [
    (_ctx.isPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
  ], 16))
}